module.exports = __webpack_public_path__ + "img/g.6e330bd8.svg";